var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ez-user-list',{attrs:{"users":_vm.users,"columns":['name', 'email', 'role', 'accountName'],"headers":{
        accountName: () => `${_vm.$helpers.remapNaming('venue')}`,
      },"columnProps":{
        venue: { class: 'venue-cell' },
        role: { class: 'role-cell' },
      }},on:{"addUser":_vm.onAddUser,"userClick":_vm.onUserClick,"removeUser":_vm.onRemoveUser}},[_c('ez-venue-user-modal',{ref:"userModal",attrs:{"roles":_vm.roles,"formKey":_vm.formKey,"formAction":_vm.formAction,"groupId":_vm.groupId,"userId":_vm.selectedUserId}})],1),_c('ez-loader',{attrs:{"show":_vm.isLoading}},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }